import {
  COUNTRY_CODES,
  CURRENCY_CODES,
  CURRENCY_SYMBOLS,
  COUNTRIES,
  LOCALES,
  COUNTRY_NAMES
} from '../Constants/Country'

const countryCodeMap = {
  [COUNTRIES.SG]: COUNTRY_CODES.SG,
  [COUNTRIES.MY]: COUNTRY_CODES.MY,
  [COUNTRIES.ID]: COUNTRY_CODES.ID,
  [COUNTRIES.VN]: COUNTRY_CODES.VN,
  [COUNTRIES.PH]: COUNTRY_CODES.PH,
  [COUNTRIES.TH]: COUNTRY_CODES.TH,
  [COUNTRIES.MM]: COUNTRY_CODES.MM,
  [COUNTRIES.MA]: COUNTRY_CODES.MA
}
const currencyCodeMap = {
  [COUNTRIES.SG]: CURRENCY_CODES.SGD,
  [COUNTRIES.MY]: CURRENCY_CODES.MYR,
  [COUNTRIES.ID]: CURRENCY_CODES.IDR,
  [COUNTRIES.VN]: CURRENCY_CODES.VND,
  [COUNTRIES.PH]: CURRENCY_CODES.PHP,
  [COUNTRIES.TH]: CURRENCY_CODES.THB,
  [COUNTRIES.MM]: CURRENCY_CODES.MMK,
  [COUNTRIES.MA]: CURRENCY_CODES.MAD
}
const currencySymbolMap = {
  [COUNTRIES.SG]: CURRENCY_SYMBOLS.SGD,
  [COUNTRIES.MY]: CURRENCY_SYMBOLS.MYR,
  [COUNTRIES.ID]: CURRENCY_SYMBOLS.IDR,
  [COUNTRIES.VN]: CURRENCY_SYMBOLS.VND,
  [COUNTRIES.PH]: CURRENCY_SYMBOLS.PHP,
  [COUNTRIES.TH]: CURRENCY_SYMBOLS.THB,
  [COUNTRIES.MM]: CURRENCY_SYMBOLS.MMK,
  [COUNTRIES.MA]: CURRENCY_SYMBOLS.MAD
}
const localeMap = {
  [COUNTRIES.SG]: LOCALES.SG,
  [COUNTRIES.MY]: LOCALES.MY,
  [COUNTRIES.ID]: LOCALES.ID,
  [COUNTRIES.VN]: LOCALES.VN,
  [COUNTRIES.PH]: LOCALES.PH,
  [COUNTRIES.TH]: LOCALES.TH,
  [COUNTRIES.MM]: LOCALES.MM,
  [COUNTRIES.MA]: LOCALES.MA
}
const countryNameMap = {
  [COUNTRIES.SG]: COUNTRY_NAMES.SG,
  [COUNTRIES.MY]: COUNTRY_NAMES.MY,
  [COUNTRIES.ID]: COUNTRY_NAMES.ID,
  [COUNTRIES.VN]: COUNTRY_NAMES.VN,
  [COUNTRIES.PH]: COUNTRY_NAMES.PH,
  [COUNTRIES.TH]: COUNTRY_NAMES.TH,
  [COUNTRIES.MM]: COUNTRY_NAMES.MM,
  [COUNTRIES.MA]: COUNTRY_NAMES.MA
}

const getCountryCode = id => countryCodeMap[id && id.toLowerCase()] || ''
const getCurrencyCode = id => currencyCodeMap[id && id.toLowerCase()] || ''
const getCurrencySymbol = id => currencySymbolMap[id && id.toLowerCase()] || ''
const getLocale = id => localeMap[id && id.toLowerCase()] || ''
const getCountryNames = id => countryNameMap[id && id.toLowerCase()] || ''

const getPostcodeInfo = identifier => {
  const id = identifier && identifier.toLowerCase()
  switch (id) {
    case COUNTRIES.SG:
      return { length: 6, required: true }
    case COUNTRIES.VN:
      return { length: 6 }
    case COUNTRIES.ID:
    case COUNTRIES.MA:
      return { length: 5 }
    case COUNTRIES.MY:
    case COUNTRIES.TH:
    case COUNTRIES.MM:
      return { length: 5, required: true }
    case COUNTRIES.PH:
      return { length: 4 }
    default:
      return ''
  }
}

const getSizeInfo = identifier => {
  const id = identifier && identifier.toLowerCase()
  switch (id) {
    case COUNTRIES.SG:
      return { required: true }
    default:
      return {}
  }
}

const getWeightInfo = identifier => {
  const id = identifier && identifier.toLowerCase()
  switch (id) {
    case COUNTRIES.MY:
    case COUNTRIES.TH:
    case COUNTRIES.ID:
    case COUNTRIES.VN:
    case COUNTRIES.PH:
      return { required: true }
    default:
      return {}
  }
}

const getPickupTimeslotInfo = identifier => {
  const id = identifier && identifier.toLowerCase()
  switch (id) {
    case COUNTRIES.VN:
      return [
        { id: 0, range: [9, 12] },
        { id: 1, range: [12, 15] },
        { id: 2, range: [15, 18] },
        { id: -1, range: [9, 22] }
      ]
    default:
      return [
        { id: 0, range: [9, 12] },
        { id: 1, range: [12, 15] },
        { id: 2, range: [15, 18] },
        { id: 3, range: [18, 22] },
        { id: -2, range: [9, 18] },
        { id: -1, range: [9, 22] }
      ]
  }
}

const getDeliveryTimeslotInfo = identifier => {
  const id = identifier && identifier.toLowerCase()
  switch (id) {
    case COUNTRIES.SG:
    case COUNTRIES.MM:
      return [
        { id: 0, range: [9, 12] },
        { id: 1, range: [12, 15] },
        { id: 2, range: [15, 18] },
        { id: 3, range: [18, 22] },
        { id: -2, range: [9, 18] },
        { id: -1, range: [9, 22] }
      ]
    default:
      return [{ id: -1, range: [9, 22] }]
  }
}

const getAddressInfo = identifier => {
  const id = identifier && identifier.toLowerCase()
  switch (id) {
    case COUNTRIES.MA:
      return {
        neighborhood: 'district',
        locality: 'city',
        region: 'province'
      }
    case COUNTRIES.MY:
      return {
        neighborhood: 'area',
        locality: 'city',
        region: 'state'
      }
    case COUNTRIES.ID:
      return {
        neighborhood: 'kecamatan',
        locality: 'city',
        region: 'province'
      }
    case COUNTRIES.VN:
      return {
        neighborhood: 'ward',
        locality: 'district',
        region: 'city'
      }
    case COUNTRIES.TH:
      return {
        neighborhood: 'sub_district',
        locality: 'district',
        region: 'province'
      }
    case COUNTRIES.PH:
      return {
        neighborhood: 'district',
        locality: 'city',
        region: 'province'
      }
    case COUNTRIES.MM:
      return {
        neighborhood: 'township',
        locality: 'district',
        region: 'state'
      }
    default:
      return {}
  }
}

const getAddressMapping = countryId => {
  switch (countryId && countryId.toLowerCase()) {
    case COUNTRIES.MY:
      return {
        street_number: 'building_no',
        route: 'street',
        premise: 'building',
        establishment: 'building',
        sublocality: 'area',
        sublocality_level_1: 'area',
        neighborhood: 'area',
        locality: 'city',
        administrative_area_level_1: 'state',
        postal_code: 'postcode'
      }
    case COUNTRIES.ID:
      return {
        street_number: 'building_no',
        route: 'street',
        premise: 'building',
        establishment: 'building',
        administrative_area_level_4: 'community',
        administrative_area_level_3: 'district',
        administrative_area_level_2: 'city',
        administrative_area_level_1: 'province',
        postal_code: 'postcode'
      }
    case COUNTRIES.VN:
      return {
        street_number: 'building_no',
        route: 'street',
        premise: 'building',
        neighborhood: 'building',
        sublocality: 'ward',
        sublocality_level_1: 'ward',
        administrative_area_level_2: 'district',
        administrative_area_level_1: 'city',
        locality: 'city',
        postal_code: 'postcode'
      }
    case COUNTRIES.PH:
      return {
        street_number: 'building_no',
        route: 'street',
        premise: 'building',
        establishment: 'building',
        neighborhood: 'subdivision',
        sublocality: 'district',
        sublocality_level_1: 'district',
        locality: 'city',
        administrative_area_level_2: 'city',
        administrative_area_level_1: 'province',
        postal_code: 'postcode'
      }
    case COUNTRIES.TH:
      return {
        street_number: 'building_no',
        route: 'street',
        premise: 'building',
        establishment: 'building',
        neighborhood: 'building',
        sublocality_level_1: 'subdistrict',
        administrative_area_level_2: 'district',
        administrative_area_level_1: 'province',
        postal_code: 'postcode'
      }
    default:
      return {}
  }
}

const getDefaultLatLng = countryId => {
  switch (countryId && countryId.toLowerCase()) {
    case COUNTRIES.SG:
      return {
        lat: 1.2910042,
        lng: 103.8504413
      }
    case COUNTRIES.MY:
      return {
        lat: 3.1412,
        lng: 101.68653
      }
    case COUNTRIES.ID:
      return {
        lat: -6.21462,
        lng: 106.84513
      }
    case COUNTRIES.VN:
      return {
        lat: 10.82302,
        lng: 106.62965
      }
    case COUNTRIES.PH:
      return {
        lat: 14.6042,
        lng: 120.9822
      }
    case COUNTRIES.TH:
      return {
        lat: 13.75398,
        lng: 100.50144
      }
    case COUNTRIES.MM:
      return {
        lat: 16.80528,
        lng: 96.15611
      }
    case COUNTRIES.MA:
      return {
        lat: 31.7215845,
        lng: -11.6529407
      }
    default:
      return {}
  }
}

export default {
  getCountryCode,
  getCurrencyCode,
  getCurrencySymbol,
  getLocale,
  getCountryNames,
  getPostcodeInfo,
  getSizeInfo,
  getWeightInfo,
  getAddressInfo,
  getAddressMapping,
  getPickupTimeslotInfo,
  getDeliveryTimeslotInfo,
  getDefaultLatLng
}
